import type { StepProps } from "../app";
import { ContactExpert } from "../ContactExpert";

export function Step5Confirmation({ state, stepName }: StepProps) {
  return (
    <section class="step confirmation">
      <div class="checkmark" aria-hidden="true">✓</div>
      <h2>Your contract is on its way</h2>
      <p>
        Thanks, {state.firstName}. We've emailed your agreement to <strong>{state.email}</strong> via
        DocuSign. Sign there and pay the engineering fee to lock in your install slot.
      </p>
      <p class="hint">Reference: {state.submissionId}</p>
      <div class="actions actions-center">
        <ContactExpert stepName={stepName} submissionId={state.submissionId} />
      </div>
    </section>
  );
}
